// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Fmau","productName":"Table_productName__t_Xx2"};